import { CHART_CONFIG, METRIC_TYPES, MetricType } from '../config/chart-config';

import { TabType } from '@/routes/dashboards/shared-types';

import { Line, Bar, Cell } from 'recharts';
import { MetricsDataPoint } from './revenue-metrics-chart';

// Helper function to determine which series should be highlighted
const shouldHighlightSeries = (metric: MetricType, tab: TabType): boolean => {
  switch (tab) {
    case 'directRevenue':
      return metric === METRIC_TYPES.FLOWS_REVENUE;
    case 'influencedRevenue':
      return metric === METRIC_TYPES.LIFECYCLE_REVENUE;
    default:
      return true;
  }
};

export const renderMetric = (
  metric: MetricType,
  initialTab: TabType,
  data?: MetricsDataPoint[]
) => {
  const config = CHART_CONFIG[metric];

  switch (initialTab) {
    case 'anonVisitors':
    case 'events': {
      return (
        <Line
          key={metric}
          type="monotone"
          dataKey={metric}
          stroke={config.color}
          strokeWidth={2}
          dot={false}
          activeDot={{ r: 2, fill: config.color }}
        />
      );
    }

    case 'revenue': {
      // Render as stacked bars (legacy)
      const isBottomBar = metric === METRIC_TYPES.LIFECYCLE_REVENUE;
      const isTopBar = metric === METRIC_TYPES.FLOWS_REVENUE;

      const radius: [number, number, number, number] = isBottomBar
        ? [0, 0, 4, 4]
        : isTopBar
          ? [4, 4, 0, 0]
          : [0, 0, 0, 0];

      return (
        <Bar key={metric} dataKey={metric} fill={config.color} radius={radius} stackId="revenue" />
      );
    }

    case 'directRevenue':
    case 'influencedRevenue': {
      const isHighlighted = shouldHighlightSeries(metric, initialTab);

      return (
        <Bar key={metric} dataKey={metric} fill={config.color} radius={[4, 4, 4, 4]}>
          {data?.map((_, index) => (
            <Cell key={`cell-${index}`} fillOpacity={isHighlighted ? 1.0 : 0.3} />
          ))}
        </Bar>
      );
    }

    default: {
      // Fallback for any future tab types
      return <Bar key={metric} dataKey={metric} fill={config.color} radius={[4, 4, 4, 4]} />;
    }
  }
};
